import http from '../http-common';

const API_URL_PATH = 'profilers/';
const API_URL_PATH_WITHOUT_BAR = 'profilers';
const API_URL_PATH_UTILS = 'utils/';

class VirtualProfilersDataService {
  findAll(page, limit) {
    return http.get(API_URL_PATH_WITHOUT_BAR + '?page=' + page + '&limit=' + limit);
  }

  findOne(id) {
    return http.get(API_URL_PATH + id);
  }

  create(virtualProfiler) {
    return http.post(API_URL_PATH, virtualProfiler);
  }

  assign(id) {
    return http.post(API_URL_PATH + id);
  }

  unassign() {
    return http.patch(API_URL_PATH);
  }

  findAllVirtualProfilerVoices() {
    return http.get(API_URL_PATH_UTILS + 'voices');
  }

  findVirtualProfilerVoicesByService(service) {
    return http.get(API_URL_PATH_UTILS + 'voices?type=' + service);
  }

  findFormOptions() {
    return http.get(API_URL_PATH_UTILS + 'form-profilers');
  }

  findProfilerModels() {
    return http.get(API_URL_PATH_UTILS + 'form-profilers-models');
  }
}

export default new VirtualProfilersDataService();
